import request from '@/utils/request'

function unwrap(promise, fallbackMessage) {
  return promise.then(response => {
    const result = response.data
    if (result && Number(result.code) === 0) return result
    throw new Error(result && result.msg || fallbackMessage)
  })
}

export function getFestivalConfig(params) {
  return unwrap(request({
    url: '/festival.admin.getConfig',
    method: 'get',
    params
  }), '获取节日专题配置失败')
}

export function saveFestivalDraft(data) {
  return unwrap(request({
    url: '/festival.admin.saveDraft',
    method: 'post',
    data
  }), '保存节日专题草稿失败')
}

export function publishFestivalConfig(data) {
  return unwrap(request({
    url: '/festival.admin.publish',
    method: 'post',
    data
  }), '发布节日专题失败')
}

export function listFestivalProducts(params) {
  return unwrap(request({
    url: '/festival.admin.listProducts',
    method: 'get',
    params
  }), '获取节日商品库失败')
}

export function saveFestivalProduct(data) {
  return unwrap(request({
    url: '/festival.admin.saveProduct',
    method: 'post',
    data
  }), '保存节日商品失败')
}

export function deleteFestivalProduct(data) {
  return unwrap(request({
    url: '/festival.admin.deleteProduct',
    method: 'post',
    data
  }), '删除节日商品失败')
}

export function listFestivalOrders(params) {
  return unwrap(request({
    url: '/festival.admin.listOrders',
    method: 'get',
    params
  }), '获取节日订单失败')
}

export function fulfillFestivalOrder(data) {
  return unwrap(request({
    url: '/festival.admin.fulfillOrder',
    method: 'post',
    data
  }), '更新节日订单履约状态失败')
}

export function auditFestivalRefund(data) {
  return unwrap(request({
    url: '/festival.admin.auditRefund',
    method: 'post',
    data
  }), '处理节日订单退款失败')
}
